import {
  createUnifiedTheme,
  genPageTheme,
  shapes,
  UnifiedTheme,
  palettes,
} from '@backstage/theme';

// Slalom brand colors
const slalomColors = {
  primary: '#0C62FB', // Slalom Blue
  secondary: '#00B2A9', // Slalom Teal
  accent: '#F26522', // Slalom Orange
};

export const slalomLightTheme: UnifiedTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: slalomColors.primary,
    },
    secondary: {
      main: slalomColors.secondary,
    },
    background: {
      default: '#EEEEEE', // Main display pane grey
      paper: '#FFFFFF',
    },
    navigation: {
      background: '#FFFFFF', // Sidebar white
      indicator: slalomColors.primary, // Use primary blue for consistency
      color: '#757575', // Light grey for unselected menu text
      selectedColor: '#000000', // Black for selected menu text
      navItem: {
        hoverBackground: '#E8F0FF', // Subtle blue tint for hover
      },
    },
  },
  defaultPageTheme: 'home',
  fontFamily: '"Slalom Sans", Arial, Helvetica, sans-serif',
  /* istanbul ignore next */
  pageTheme: {
    home: genPageTheme({
      colors: [slalomColors.primary, slalomColors.secondary],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: [slalomColors.primary, slalomColors.secondary],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: [slalomColors.primary, slalomColors.secondary],
      shape: shapes.wave,
    }),
    service: genPageTheme({
      colors: [slalomColors.primary, slalomColors.secondary],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: [slalomColors.primary, slalomColors.secondary],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: [slalomColors.primary, slalomColors.secondary],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: [slalomColors.primary, slalomColors.secondary],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: [slalomColors.primary, slalomColors.accent],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: [slalomColors.secondary, slalomColors.primary],
      shape: shapes.wave,
    }),
  },
});

export const slalomDarkTheme: UnifiedTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: {
      main: '#4A90E2', // Lighter blue for dark mode
    },
    secondary: {
      main: slalomColors.secondary,
    },
    background: {
      default: '#1E1E1E', // Main display pane (dark mode)
      paper: '#2A2A2A', // Cards and paper components (dark mode)
    },
    navigation: {
      background: '#1A1A1A',
      indicator: slalomColors.secondary,
      color: '#FFFFFF',
      selectedColor: '#FFFFFF',
      navItem: {
        hoverBackground: '#282828', // Subtle dark tint for dark mode hover
      },
    },
  },
  defaultPageTheme: 'home',
  fontFamily: '"Slalom Sans", Arial, Helvetica, sans-serif',
  /* istanbul ignore next */
  pageTheme: {
    home: genPageTheme({
      colors: ['#4A90E2', slalomColors.secondary],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#4A90E2', slalomColors.secondary],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#4A90E2', slalomColors.secondary],
      shape: shapes.wave,
    }),
    service: genPageTheme({
      colors: ['#4A90E2', slalomColors.secondary],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#4A90E2', slalomColors.secondary],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#4A90E2', slalomColors.secondary],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#4A90E2', slalomColors.secondary],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: ['#4A90E2', slalomColors.accent],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: [slalomColors.secondary, '#4A90E2'],
      shape: shapes.wave,
    }),
  },
});
